const draggable = (el) => {
  $(el).draggable({
    revert: true,
    revertDuration: 0,
    helper: 'clone', // clona
    appendTo: 'body', // clona para o body
    start: function (event, ui) {
      // hide original when showing clone
      $(ui.helper).css('width', $(event.target)[0].offsetWidth)
      $(this).hide()
    },
    stop: function () {
      // show original when hiding clone
      $(this).show()
    }
  })
}

const droppable = (el, binding) => {
  let onUpdate = binding.value.onUpdate

  draggable($(el).find('.draggable'))

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if ($(node).hasClass('draggable')) {
            draggable(node)
          }
        })
      }
    })
  })

  observer.observe(el, { childList: true, subtree: true })

  $(el)
    .find('.droppable')
    .droppable({
      accept: function (dropElem) {
        return $(dropElem).is('.draggable')
      },
      classes: {
        'ui-droppable-hover': 'ui-state-hover'
      },
      drop: function (event, ui) {
        var item = ui.draggable
        var list = event.target

        const itemData = $(item).attr('data-draggable')
        const listData = $(list).attr('data-droppable')

        if (onUpdate) {
          onUpdate({
            item: itemData,
            toList: listData
          })
        }
      }
    })
}

const checkHas = (el, binding) => {
  if (!$(el).attr('dragg') && !binding.value.disabled) {
    $(el).attr('dragg', 1)
    droppable(el, binding)
  }
}

export default {
  update: function (el, binding, vnode) {
    checkHas(el, binding)
  },
  inserted: function (el, binding, vnode) {
    checkHas(el, binding)
  }
}



// WEBPACK FOOTER //
// ./src/directives/ConnectedDroppable.js